import './ListPage.scss';
import { SimpleNumberCard } from '@design-system/index';
import { CustomersListLine } from '@icons';
import { MutationTable } from '@components/Table/MutationTable/MutationTable';
import { MemberTable } from '@services/member/member/member.types';
import { ColumnDef } from '@tanstack/react-table';
import { formatDate } from '@utils/dates';
import { useListPageVM } from './useListPageVM';
import { useGetCustomersMutation } from '@services/product/customer/customer.endpoints';

export default function ListPage() {
    const { handleMetadata, navigate, columnHelper, totalCustomers } = useListPageVM();

    const columns = [
        columnHelper.accessor('cosemNumber', { 
            header: 'N°COSEM',
            enableSorting: true,
            meta: {
                clickable: true
            },
            cell: (info) => <>{info.getValue()}</> 
        }),
        columnHelper.accessor((row) => row.administrativeInformation.registrationNumber, {
            id: 'administrativeInformation.registrationNumber',
            header: 'Matricule',
            meta: {
                clickable: true
            },
            enableSorting: true,
            cell: (info) => <>{info.getValue()}</>
        }),
        columnHelper.accessor((row) => row.administrativeInformation.registeredAt, {
            id: 'administrativeInformation.registeredAt',
            header: "Date d'adhésion",
            meta: {
                clickable: true
            },
            enableSorting: true,
            cell: (info) => <>{formatDate(info.getValue())}</>
        }),
        columnHelper.accessor((row) => row.personalInformation.lastname, {
            id: 'personalInformation.lastname',
            header: 'Nom',
            meta: {
                clickable: true
            },
            enableSorting: true,
            cell: (info) => <>{info.getValue().toUpperCase()}</>
        }),
        columnHelper.accessor((row) => row.personalInformation.firstname, {
            id: 'personalInformation.firstname',
            header: 'Prénom',
            meta: {
                clickable: true
            },
            enableSorting: true,
            cell: (info) => <>{info.getValue().toUpperCase()}</>
        }),
    ] as ColumnDef<MemberTable>[];

    return (        
        <div className="customers-table-container">
            <div className="customers-table-container-header">
                <div className="customers-table-container-header-left">
                    <SimpleNumberCard labelForSingle={'Client'} labelForMultiple={'Clients'} value={totalCustomers} />
                </div>
            </div>
            <MutationTable
                key={'customers'}
                columns={columns}
                mutationHook={useGetCustomersMutation}
                onRowClick={(row) => navigate(`/products-management/customers/${row.id}/details`)}
                defaultSorting={{
                    field: 'cosemNumber',
                    direction: 'desc'
                }}
                selectable={false}
                headerTitle={'Liste des clients'}
                headerIcon={<CustomersListLine />}
                onMetadata={handleMetadata}
            />
        </div>
    );
};
